import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from './Services/loader.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MediaMatcher } from '@angular/cdk/layout';
import { StorageService } from './Services/storage.service';
import { SharedService } from './Services/shared.service';
import { SnackBarService } from './Services/snackbar.service';
import { BreadcrumbService } from './Services/breadcrumb.service';
import { fromEvent, merge, Observable, Observer } from 'rxjs';
import { MatSnackBar } from "@angular/material/snack-bar";
import { map } from 'rxjs/operators';

export const DD_MM_YYYY_Format = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    //{ provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_Format },
  ]
})
export class AppComponent {
  title = 'dashboard';
  collection = [];
  name = new FormControl();
  isShowDirectives = false;
  isShowl = false;
  sideBarOpen = false;
  mobileQuery: MediaQueryList;
  mobileSideBar = true;
  iconMenu: any = '50px';
  menuWithIcon: any = '180px';
  public href = '';
  isShowContent = true;
  token: any;
  breadcrumbList: Array<any> = [];
  private _mobileQueryListener: () => void;
  menu: any = []
  isShow: boolean;
  constructor(changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public storage: StorageService,
    private router: Router,
    public shared: SharedService,
    public snackBar: SnackBarService,
    private snackBarMat: MatSnackBar,
    private menuService: BreadcrumbService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public loader: LoaderService,) {
    this.menu = this.menuService.getMenu();
    this.listenRouting();
    this.shared._subject.subscribe((data: any) => {
      if (data.type == 'navBar') {
        this.isShowDirectives = data.isShowNavbar;
      }
      // console.log(data.isShowNavbar, this.isShowDirectives);
    });
    this.loader.loaderState.subscribe((res: any) => {
      if (res.show) {
        this.spinner.show();
      } else {
        this.spinner.hide();

      }
    });
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.createOnline$().subscribe(isOnline => {
      if (navigator.onLine) {
        this.isShow = true
        // console.log("You are Online")
        this.snackBarMat.dismiss();
      }
      else {
        this.isShow = false
        //  console.log("You are Offline")
         this.snackBarMat.open(`No Internet`)
      }
    });

    this.href = this.router.url;
    this.mobileSideBar = !this.mobileQuery.matches;
    this.urlRemove();
  }
  createOnline$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((subscribe: Observer<boolean>) => {
        subscribe.next(navigator.onLine);
        subscribe.complete();
      }));
  }
  urlRemove() {
    const url3 = this.href.split('/')[3];
    const url = this.href.split('/')[2];
    let url2, token;
    if (url && url.includes('?')) {
      url2 = url.split('?')[0];
      token = url.split('?token=')[1];
    }


    this.storage.setData({ master_token: token });
    // this.token = this.href.split('?token=')[2]
    // console.log(url2,'token',token)
    if (url == 'login' || url == 'active-link' || url2 == 'update-password' || url == 'update-password' || url3 == 'login') {
      this.isShowContent = false;
      this.isShowDirectives = true;
    } else {
      this.isShowContent = true;
      this.isShowDirectives = false;
    }
  }
  sideBarToggler(val?) {
    // console.log(val)
    this.isShowl = !this.isShowl;
    this.sideBarOpen = !this.sideBarOpen;
    if (this.mobileQuery.matches) {
      this.mobileSideBar = !this.mobileSideBar;
    }
  }


  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  // resposive menu time decomment
  fun() {
    this.sideBarToggler();
  }


  triggerSnackbar() {
    const config = {
      message: '<p class=\'p-0 m-0\'> <span > <i class=\'ms-Icon ms-Icon--InfoSolid text-primary h4 m-0 p-0 icon\' aria-hidden=\'true\'> </i> </span> Notification! </p>',
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      duration: 5000000
    };

    const snackBarRef: any = this.snackBar.openSnackBar(config);

  }
  listenRouting() {
    let routerUrl: string, routerList: Array<any>, target: any;
    this.router.events.subscribe((router: any) => {
      routerUrl = router.urlAfterRedirects;
      if (routerUrl && typeof routerUrl === 'string') {
        target = this.menu;
        this.breadcrumbList.length = 0;
        routerList = routerUrl.slice(1).split('/');
        routerList.forEach((router, index) => {
          if (target != undefined) {
            target = target.find(page => page.path.slice(1) === router);
            if (target != undefined) {
              this.breadcrumbList.push({
                name: target.name,
                path:
                  index === 0
                    ? target.path
                    : `${this.breadcrumbList[index - 1].path}/${target.path.slice(
                      1
                    )}`
              });
            }

            if (index + 1 !== routerList.length && target) {
              target = target.children;
              // console.log('target --> ', target)
            }
          }
          if (routerList.length == index + 1) {
            // console.log('Bread C', this.breadcrumbList);

          }
        });

      }
    });
  }

}
